import {createSelector} from '@reduxjs/toolkit'

import {eq, gtZero} from '@shared/helpers/lang'

import {PayLaterMemberStatus, PayLaterPromotionBannerStatus} from '@web/core/constants'

import {RootState} from './interfaces'

/** 후불결제 */
export const payLaterSelector = (state: RootState) => state.payLater

/** 후불결제 유도배너 타입 */
export const payLaterPromotionBannerStatusSelector = createSelector(
    payLaterSelector,
    ({memberStatus, availableAmount}) => {
        const statusEqualTo = eq(memberStatus)
        if (statusEqualTo(PayLaterMemberStatus.SIGNUP)) {
            return PayLaterPromotionBannerStatus.SIGNUP
        } else if (statusEqualTo(PayLaterMemberStatus.NORMAL) && gtZero(availableAmount)) {
            return PayLaterPromotionBannerStatus.USE
        } else {
            return PayLaterPromotionBannerStatus.NONE
        }
    },
)
